const loginActionTypes = {
    GET_LOGIN_INFO: 'GET_LOGIN_INFO',
    GET_LOGIN_INFO_SUCCESS: 'GET_LOGIN_INFO_SUCCESS',
    GET_LOGIN_INFO_FAIL: 'GET_LOGIN_INFO_FAIL',
}

export default loginActionTypes;